import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const SchoolUniform = () => {
     useEffect(() => {
        document.title = 'School Uniform -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
     <li>  Academics</li> 
     <li>School Uniform</li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>School Uniform </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <iframe src="https://webapi.entab.info/api/image/STPSFH/public/pdf/SchoolUniform.pdf" width="100%" height="600"></iframe>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default SchoolUniform
